<template>
  <div class="right-box-2">
    <div class="item">
      <div class="item-header"></div>
      <div class="item-content">
        <div class="content-box">
          <div class="img-item" v-for="(item, index) in mainBody.attributeCount" :key="index">
            <img src="@/assets/imgs/base_right/content-1.png" />
            <div class="info">
              <div>{{ subjectAttribute[+item.label] }}</div>
              <span>{{ item.value || 0 }}</span>
              <!-- <div>
                本周新增
                <div>15</div>
                <img src="@/assets/imgs/base_right/up.png" />
              </div> -->
            </div>
          </div>
        </div>
        <div class="other-content">
          <div class="other-item">
            <div class="other-header">
              <span>活跃主体数量</span>
            </div>
            <div class="other-chart" id="barChart"></div>
          </div>
          <div class="center-box">
            <div class="center-item" style="margin-top: auto">
              <span>234</span>
              <div class="end_txt">家</div>
            </div>
            <div class="end_txt">本周新增主体</div>
            <div class="center-item" style="margin-top: 40px">
              <span>394</span>
              <div class="end_txt">家</div>
            </div>
            <div class="end_txt">近七日活跃主体</div>
          </div>
          <div class="other-item" style="margin-left: auto">
            <div class="other-header">
              <span>生产经营主体行业占比</span>
            </div>
            <div class="other-chart" id="pieChart"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 表格 -->
    <div class="item">
      <div class="item-header"></div>
      <div class="item-content">
        <!-- {{newRankList}} -->
        <rankBox v-model="newRankList" :header="currentHeader" :errorTxt="['已停产', '注销']" @load="load"></rankBox>
      </div>
    </div>
  </div>
</template>
<script>
import indexMins from "@/mixins/right.js";
import rankBox from "../rank/index.vue";
import { request_get } from "@/utils/request.js"
export default {
  mixins: [indexMins],
  components: { rankBox },
  props: {
    cityInfo: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      currentCityInfo: {},
      mainBody: {},
      list: [],
      currentHeader: [],
      rankList: [
        {
          values: [
            "北京吉浪文化传媒有限公司",
            "企业",
            "生产主体",
            "畜牧业",
            "正常",
            "2021/01/01 19:00",
          ],
        },
        {
          values: [
            "北京吉浪文化传媒有限公司",
            "企业",
            "生产主体",
            "畜牧业",
            "异常",
            "2021/01/01 19:00",
          ],
        },
        {
          values: [
            "北京吉浪文化传媒有限公司",
            "企业",
            "生产主体",
            "畜牧业",
            "正常",
            "2021/01/01 19:00",
          ],
        },
        {
          values: [
            "北京吉浪文化传媒有限公司",
            "企业",
            "生产主体",
            "畜牧业",
            "异常",
            "2021/01/01 19:00",
          ],
        },
        {
          values: [
            "北京吉浪文化传媒有限公司",
            "企业",
            "生产主体",
            "畜牧业",
            "正常",
            "2021/01/01 19:00",
          ],
        },
        {
          values: [
            "北京吉浪文化传媒有限公司",
            "企业",
            "生产主体",
            "畜牧业",
            "异常",
            "2021/01/01 19:00",
          ],
        },
        {
          values: [
            "北京吉浪文化传媒有限公司",
            "企业",
            "生产主体",
            "畜牧业",
            "正常",
            "2021/01/01 19:00",
          ],
        },
        {
          values: [
            "北京吉浪文化传媒有限公司",
            "企业",
            "生产主体",
            "畜牧业",
            "异常",
            "2021/01/01 19:00",
          ],
        },
        {
          values: [
            "北京吉浪文化传媒有限公司",
            "企业",
            "生产主体",
            "畜牧业",
            "正常",
            "2021/01/01 19:00",
          ],
        },
        {
          values: [
            "北京吉浪文化传媒有限公司",
            "企业",
            "生产主体",
            "畜牧业",
            "异常",
            "2021/01/01 19:00",
          ],
        },
        {
          values: [
            "北京吉浪文化传媒有限公司",
            "企业",
            "生产主体",
            "畜牧业",
            "正常",
            "2021/01/01 19:00",
          ],
        },
        {
          values: [
            "北京吉浪文化传媒有限公司",
            "企业",
            "生产主体",
            "畜牧业",
            "异常",
            "2021/01/01 19:00",
          ],
        },
        {
          values: [
            "北京吉浪文化传媒有限公司",
            "企业",
            "生产主体",
            "畜牧业",
            "正常",
            "2021/01/01 19:00",
          ],
        },
        {
          values: [
            "北京吉浪文化传媒有限公司",
            "企业",
            "生产主体",
            "畜牧业",
            "异常",
            "2021/01/01 19:00",
          ],
        },
      ],
      // 主体行业
      businessType: {
        1: "种植业",
        2: "畜牧业",
        3: "水产业",
        4: "其他行业"
      },
      // 主体属性
      subjectAttribute: {
        1: "生产主体",
        2: "屠宰场",
        3: "生鲜乳企业",
        4: "投入品经营主体",
        5: "加工企业",
        6: "其他"
      },
      // 公司类型
      enterpriseType: {
        1: "企业/个体工商户",
        2: "合作社",
        3: "家庭农场",
        4: "个体小散户",
        5: "种植大户",
        6: "其它"
      },
      // 状态
      status: {
        0: "正常",
        1: "注销",
        3: "已停产"
      },
      page: 1,
    };
  },
  watch: {
    cityInfo: {
      handler(val) {
        this.currentCityInfo = val;
        this.currentHeader = ['序号', val.name || '呼和浩特', '主体行业', '主体属性', '公司类型', '状态']
        this.page = 1;
        this.list = [];
        this.getMianData();

      },
      deep: true
    }
  },
  computed: {
    newRankList: function () {
      return this.list.map((ele, index) => {
        return {
          values: [index + 1, ele.bodyName, this.enterpriseType[Number(ele.enterpriseType)], this.subjectAttribute[+ele.subjectAttribute], this.enterpriseType[+ele.enterpriseType], this.status[+ele.status]]
        }
      })
    }
  },
  async mounted() {
    this.currentCityInfo = this.cityInfo;
    this.currentHeader = ['序号', this.cityInfo.name || '呼和浩特', '主体行业', '主体属性', '公司类型', '状态']
    this.getMianData()

  },
  methods: {
    load() {
      this.page += 1;
      this.getMianData()
    },
    getMianData() {
      request_get("/lsd/mainBody/count", { area: this.currentCityInfo?.name, page: this.page, pageSize: 20 }, res => {
        if (res.code == 200) {
          if (this.page == 1) {
            this.mainBody = res.data;
            this.$nextTick(function () {
              this.rightBarSubject(document.getElementById("barChart"), this.mainBody, this.subjectAttribute);
              this.initRightBuession(document.getElementById("pieChart"), this.mainBody, this.businessType);
            })
          }
          this.list = [...this.list, ...res.data.mainBodyList]
        }
      })
    },
  }
};
</script>
<style lang="scss" scoped>
.right-box-2 {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  .item {
    max-height: 50%;
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 15px;
    background: linear-gradient(-270deg,
        rgba(37, 106, 191, 0.1) 0%,
        #031a37 100%);
    box-sizing: border-box;

    &:nth-of-type(2) {
      margin-top: 20px;
    }

    .item-header {
      height: 50px;
      width: 100%;
      background: url("../../assets/imgs/base_right/bg-3.png") no-repeat;
      background-size: 580px 100%;
    }

    .item-content {
      flex: 1;
      display: flex;
      flex-direction: column;

      .content-box {
        display: flex;
        align-items: center;

        .img-item {
          flex: 1;
          display: flex;
          align-items: center;

          img {
            width: 80px;
            height: 80px;
          }

          .info {
            margin-left: 12px;
            display: flex;
            flex-direction: column;
            color: rgba(255, 255, 255, 0.7);
            font-size: 16px;

            span {
              background: linear-gradient(90deg, #ffffff 0%, #6bbee4 99%);
              -webkit-background-clip: text;
              font-size: 24px;
              font-weight: 400;
              color: transparent;
            }

            div {
              &:nth-of-type(2) {
                display: flex;
                align-items: center;

                img {
                  width: 8px;
                  height: 12px;
                }

                div {
                  margin: 0 10px;
                }
              }
            }
          }
        }
      }

      .other-content {
        flex: 1;
        display: flex;
        margin-top: 40px;

        .other-item {
          flex: 1;
          display: flex;
          flex-direction: column;
          max-width: 490px;

          .other-header {
            height: 34px;
            width: 100%;
            background: url("../../assets/imgs/base_right/bg-4.png") no-repeat;
            background-size: 490px 100%;

            span {
              font-size: 18px;
              line-height: 34px;
              color: white;
              margin-left: 34px;
            }
          }

          .other-chart {
            flex: 1;
            max-width: 490px;
          }
        }

        .center-box {
          display: flex;
          flex-direction: column;
          padding-bottom: 40px;
          margin-left: 43px;
          box-sizing: border-box;

          .center-item {
            display: flex;
            align-items: center;

            span {
              background-image: linear-gradient(#ffffff, #39dae6);
              color: transparent;
              -webkit-background-clip: text;
              font-size: 24px;
              font-weight: bold;
              margin-right: 5px;
            }
          }

          .end_txt {
            color: white;
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>
